<template>
  <div class="login-container w3-display-container">
    <form class="w3-card w3-display-topmiddle w3-center w3-twothird w3-padding" action="#" @submit.prevent="login">
        <img alt="CMDLab" src="../assets/logo_vector.svg">
        <p>
          <input 
            class="w3-input"
            type="text" 
            v-model="user.login">
          <label>Login</label>
        </p>

        <p>
          <input class="w3-input" 
            type="password" v-model="user.pass">
          <label>Password</label>
        </p>
        <p class="w3-red" v-if="view.loginIncorrect">User name or passowrd is incorrect</p>
        <button class="w3-button"  type="submit">Log In</button>

    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'login',
  data(){
    let searchParams = new URLSearchParams(window.location.search);
    let location = searchParams.get('location');
    console.log("location is:")
    console.log(location)
    return {
      relocate: location,
      user: {
        login: "",
        pass: ""
      },
      view:{
        loginIncorrect: false
      }
    }
  },
  // beforeCreate() {
  //   console.log("location is:" + window.location.search)
  // },
  methods:{
    ...mapActions({authenticateUser:'AUTH_USER'}),
    async login(){
      console.log("login u bi***")
      this.authenticateUser({login:this.user.login, pass:this.user.pass}).then((loginStatus)=>{
        console.log("login finished!!")
        if (loginStatus == 'auth OK') {
          console.log("relocate is:" + this.relocate)
          if (this.relocate != null){
            console.log("going to location:" + this.relocate)
            this.$router.push(this.relocate)
          } else {
            console.log("goig to default")
            this.$router.push('patients')
          }
        } else {
          this.view.loginIncorrect = true
        }
      }).catch(error=>console.error(error))
    }
  }
}
</script>

<style scoped>
input { 
    text-align: center; 
}
.login-container{
  margin-left:auto;
  margin-right:auto;
}
</style>